<template>
    <div style="height: 100vh;overflow: scroll">
        <ul class="gongneng">
            <li><h1>产品分类</h1></li>
            <li>
                <el-button type="success" @click="this.$router.push('/backStage_Management/Product')">产品列表</el-button>
                <el-button type="primary" @click="dialogVisibleShow()"><i class="el-icon-circle-plus"></i>添加分类</el-button>
            </li>
        </ul>


        <div class="table">

            <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        fixed
                        prop="catId"
                        label="编号"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="catName"
                        label="分类名称"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="uniqueId"
                        label="别名"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="description"
                        label="简单描述"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="parentId"
                        label="父类元素编号"
                        width="">
                </el-table-column>

                <el-table-column
                        key="slot"
                        label="操作"
                        width="">
                    <template #default="{row}">

                        <el-button @click="handleClick(row)" type="text" size="small">修改</el-button>
                        <el-button @click="deleteClick(row)" type="text" size="small">删除</el-button>

                    </template>
                </el-table-column>

            </el-table>

        </div>
        <div>
            <el-dialog
                    title="提示"
                    v-model="dialogVisible"
                    width="70%"
                    :before-close="handleClose">
                <div>
                    <el-form ref="form" :model="form"  :rules="rules">

                        <el-form-item label="分类名称"  >

                            <el-input  v-model.trim="form.ch.catName" style="width: 40%"></el-input>
                            <el-button style="margin-left: 10px" @click="otherLanguage = !otherLanguage">多语言</el-button>

                            <div class="otherLanguage" v-show="otherLanguage">
                                <el-input  style="width: 33%" v-model.trim="form.en.catName" placeholder="分类名称(英文)"></el-input>
                                <el-input  style="width: 33%" v-model.trim="form.cht.catName" placeholder="分类名称(繁体)"></el-input>
                                <el-input  style="width: 33%" v-model.trim="form.de.catName" placeholder="分类名称(德文)"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="别名" >
                            <el-input  v-model="form.ch.uniqueId" style="width: 40%"></el-input>

                        </el-form-item>
                        <el-form-item label="上级分类">
                            <el-select v-model="form.ch.catId" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>

                        </el-form-item>

                        <el-form-item label="图标">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="imgUrl"
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccess"
                            >
                                <img v-if="form.ch.image" :src="form.ch.image" class="avatar" style="height: 200px;width: 230px"/>
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="关键字" >
                            <el-input  v-model="form.ch.keywords" style="width: 40%"></el-input>

                            <div class="otherLanguage" v-show="otherLanguage">
                                <el-input  style="width: 33%" v-model="form.en.keywords" placeholder="关键字(英文)"></el-input>
                                <el-input  style="width: 33%" v-model="form.cht.keywords" placeholder="关键字(繁体)"></el-input>
                                <el-input  style="width: 33%" v-model="form.de.keywords" placeholder="关键字(德文)"></el-input>
                            </div>
                        </el-form-item>
                        <!--                添加日期-->
                        <el-form-item label="简单描述" >
                            <el-input  v-model="form.ch.description"></el-input>
                            <div class="otherLanguage" v-show="otherLanguage">
                                <el-input  v-model="form.en.description" placeholder="简单描述(英文)" ></el-input>
                                <el-input  style="margin-top: 10px" v-model="form.cht.description" placeholder="简单描述(繁体)"></el-input>
                                <el-input  style="margin-top: 10px" v-model="form.de.description" placeholder="简单描述(德文)"></el-input>
                            </div>
                        </el-form-item>



                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">提交</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import {getCurrentInstance} from "vue";
    export default {
        name: "login",
        data() {
            return{
                options: [],
                input:'',
                currentPage:1,
                total:"",
                tableData: [],
                dialogVisible: false,
                form:{
                    ch:{catName:""},
                    en:{catName:""},
                    de:{catName:""},
                    cht:{catName:""}
                }
                ,otherLanguage:false//控制多语言
                ,rules: {
                    catName: [
                        {required: true, message: '必填', trigger: 'change'},
                    ]
                }
            }
        },
        methods: {
            handleClick(row) {
               this.dialogVisible=true

                request.get("/BackStage/productCategory/getProductCategoryById/"+row.catId).then(res => {



                    // this.form=res
                    for (let i = 0; i <res.length ; i++) {
                        if (res[i].language=="zh"){
                            this.form.ch=res[i]
                        }else if(res[i].language=="cht"){
                            this.form.cht=res[i]
                        }else if(res[i].language=="en"){
                            this.form.en=res[i]
                        }else{
                            this.form.de=res[i]
                        }
                    }

                    this.form.ch.catId=this.options[this.form.ch.parentId].value
                })
            },

            onSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid){
                        request.post("/BackStage/productCategory/ProductCategorySave",this.form).then(res => {
                            if (res.code==200){
                                this.$message({
                                    type: 'success',
                                    message: res.data
                                });
                                this.initializer()
                            }else {
                                this.$message({
                                    type: 'warning',
                                    message: res.data
                                });
                            }

                        })
                    }else{
                    }

                })

            },


            deleteClick(row){

                this.$confirm('此操作将永久删除该型号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    request.delete("/BackStage/productCategory/deleteProductCategory/"+row.catId).then(res => {
                        if (res.code==200){
                            this.$message({
                                type: 'success',
                                message: res.data

                            });
                            this.initializer()
                        }else {
                            this.$message({
                                type: 'warning',
                                message: res.data
                            });
                        }
                    })


                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            },
            dialogVisibleShow(){
                this.dialogVisible = true
                this.form={
                    ch:{language:"zh"},
                    en:{language:"en"},
                    de:{language:"de"},
                    cht:{language:"cht"}
                }
                this.form.ch.catId='未分类'
            },
            initializer(){

                request.get("/BackStage/productCategory/getProductCategory").then(res => {
                    this.tableData=res
                })

            }
        },
        beforeMount(){
            this.initializer()
            const internalInstance  = getCurrentInstance(); //  方式二，此方法在开发环境以及生产环境下都能放到组件上下文对象（推荐）
            const globalProperties = internalInstance.appContext.config.globalProperties
            const imgUrl= globalProperties.$imgUrl

            this.imgUrl=imgUrl
            request.get("/BackStage/productCategory/getparent").then(res => {
                this.options=res
            })

        }


    }
</script>

<style lang="less" scoped>

    .el-menu{
        height:100vh
    }
    .gongneng{
        padding: 20px 0;
        border-bottom: 1px solid #cccccc;
        overflow: hidden;
        li:first-child{
            float: left;
            margin-left: 10px;
        }
        li:last-child{
            float: right;
            margin-right: 10px;
        }
    }
    .xiala{
        padding: 10px;
    }
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }


    .avatar-uploader-icon {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        font-size: 28px;
        color: #8c939d;
        width: 250px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar-uploader-icon:hover {
        border-color: #409eff;
    }
    .avatar {
        width: 250px;
        height: 150px;
        display: block;
    }


    .otherLanguage{
        margin-top: 10px;

    }
</style>